<template>
  <div class="flex flex-col gap-1 w-full text-left">
    <h2 class="m-0 font-lato text-[16px] text-[#092E87]">Cause Of Failure:</h2>

    <div class="flex flex-col gap-2 w-full">
      <searchableDropdown v-model="selectedReasonId" :items="reasons" labelKey="name" valueKey="id"
        buttonText="Select Cause Of Failure" :button-warpper-class="'relative w-full'"
        :buttonClass="'!rounded-[10px] border border-[#EFEFEF] flex items-center justify-between gap-2 px-[10px] !py-[4px] min-h-[40px] w-full disabled:bg-[#EFEFEF80]'"
        :buttonTextClass="[
          'flex-1 min-w-0 text-left font-lato text-[14px] whitespace-normal',
          selectedReasonId ? 'text-[#333]' : 'text-[#ccc]'
        ]" :buttonIconClass="'hidden'"
        :dropdownListClass="'origin-top-right absolute right-0 mt-2 w-full rounded-md border border-[#EFEFEF] z-20 bg-white'"
        :dropdownListLIClass="'rounded-md overflow-hidden hover:bg-gray-200'"
        :dropdownListAnchorClass="'no-underline font-lato block px-2 py-2 text-sm cursor-pointer text-gray-700 whitespace-normal hover:bg-gray-200'"
        :dropdownSearchWrapperClass="'p-2 border-b border-[#EFEFEF]'"
        :dropdownSearchInputClass="'w-full px-2 py-1.5 rounded-[8px] border border-[#EFEFEF] outline-none font-lato text-sm !text-[#333]'"
        :noResultClass="'px-2 py-3 font-lato text-sm text-center text-[#999]'"
        searchPlaceholder="Search" noResultText="No result found"
        @select="onReasonSelect" />

      <div v-if="isOtherReason" class="w-full">
        <label for="other_cause_reason" class="block mb-1 text-sm font-medium text-gray-700">
          Other Reason <span class="text-red-500">*</span>
        </label>
        <textarea id="other_cause_reason" v-model="otherReason" name="other_cause_reason" rows="3" :maxlength="500"
          placeholder="Enter other reason" @input="otherReasonError = ''" :class="[
            'w-full p-2 rounded-[10px] border outline-none resize-none font-lato text-sm !text-[#333]',
            otherReasonError ? 'border-red-500' : 'border-[#EFEFEF]'
          ]"></textarea>
        <p v-if="otherReasonError" class="mb-0 mt-1 text-red-500 text-xs">{{ otherReasonError }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import searchableDropdown from "@/components/partialComponent/searchableDropdown.vue";

export default {
  components: {
    searchableDropdown,
  },

  data() {
    return {
      reasons: [],
      selectedReasonId: null,
      otherReason: "",
      otherReasonError: "",
    };
  },

  computed: {
    ...mapGetters(["causeOfFailure", "quoteDetail"]),

    selectedReason() {
      return this.reasons.find((item) => item.id === this.selectedReasonId) ?? null;
    },

    isOtherReason() {
      return this.selectedReason?.is_other == 1;
    },
  },

  watch: {
    causeOfFailure: function (data) {
      if (data == null) return;

      this.reasons = data.reasons ?? [];

      // pehle se save ki hui value ho to prefill kar do
      if (data.submitted != null) {
        this.selectedReasonId = data.submitted.reason_id;
        this.otherReason = data.submitted.is_other == 1 ? data.submitted.reason ?? "" : "";
      }
    },
  },

  mounted() {
    this.getCauseOfFailure({
      quote_id: this.$route.params.id,
    });
  },

  methods: {
    ...mapActions(["getCauseOfFailure", "saveCauseOfFailure"]),

    onReasonSelect() {
      if (!this.isOtherReason) {
        this.otherReason = "";
      }
      this.otherReasonError = "";
    },

    // called from QuoteEdit before the Submit Quote confirmation is shown
    validateCauseOfFailure() {
      if (!this.selectedReasonId) {
        this.showValidationDialog("Please select a cause of failure.");
        return false;
      }

      if (this.isOtherReason && (this.otherReason ?? "").trim().length <= 0) {
        this.otherReasonError = "This field is required.";
        this.showValidationDialog("Please enter the other reason.");
        return false;
      }

      this.otherReasonError = "";
      return true;
    },

    // called from QuoteEdit after the user confirms, before the quote is submitted
    submitCauseOfFailure() {
      return this.saveCauseOfFailure({
        quote_id: this.$route.params.id,
        reason_id: this.selectedReasonId,
        reason_other: this.isOtherReason ? this.otherReason.trim() : "",
      });
    },

    showValidationDialog(text) {
      this.$dialog.show({
        title: "Missing Information",
        text: text,
        image: "alert-modal-icon.png",
        buttonText: "OK",
      });
    },
  },
};
</script>
